import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod, fetchMethod } from "../../services/httpService";
import messagePopup from "../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
    PSAT_READING_AND_WRITING_LIST_START: "PSAT_READING_AND_WRITING_LIST_START",
    PSAT_READING_AND_WRITING_LIST_SUCCESS: "PSAT_READING_AND_WRITING_LIST_SUCCESS",
    PSAT_READING_AND_WRITING_LIST_FAILED: "PSAT_READING_AND_WRITING_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const psatReadingAndWritingListStart = (data) => ({
    type: actionType.PSAT_READING_AND_WRITING_LIST_START,
    payload: data,
});

export const psatReadingAndWritingListSuccess = (data) => ({
    type: actionType.PSAT_READING_AND_WRITING_LIST_SUCCESS,
    payload: data,
});

export const psatReadingAndWritingListFailed = (data) => ({
    type: actionType.PSAT_READING_AND_WRITING_LIST_FAILED,
    payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null,
};

export default function psatReadingAndWritingListReducer(state = INIT_STATE, action) {
    switch (action.type) {
        case actionType.PSAT_READING_AND_WRITING_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case actionType.PSAT_READING_AND_WRITING_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };
        case actionType.PSAT_READING_AND_WRITING_LIST_FAILED:
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload,
            };
        default:
            return { ...state };
    }
}

// ===================================================== side effect =============================================

export function* psatReadingAndWritingListSaga(action) {
    try {
        const response = yield fetchGraphMethod(action.payload.query, action.payload.variables, true);
        if (response && response.status === 200) {
            const allPSATReadingAndWriting =  response.data.data.allPsatreadingandwritings.Psatreadingandwritings
            yield put(psatReadingAndWritingListSuccess(allPSATReadingAndWriting));
        } else {
            messagePopup("", "PSAT Reading and Writing List failed", "error");
            yield put(psatReadingAndWritingListFailed("PSAT Reading and Writing List failed"));
        }
    } catch (error) {
        messagePopup("", "PSAT Reading and Writing failed", "error");
        yield put(psatReadingAndWritingListFailed("PSAT Reading and Writing List failed"));
    }
}

export function* watchPsatReadingAndWritingListSaga() {
    yield takeEvery(actionType.PSAT_READING_AND_WRITING_LIST_START, psatReadingAndWritingListSaga);
}
